import { APP_INITIALIZER, ApplicationConfig } from '@angular/core'
import { provideRouter, withInMemoryScrolling } from '@angular/router'
import { ENV, ServiceType, ApplicationType } from '@bequeathed/ngx-app-core'
import { LoaderService } from "@bequeathed/ngx-services"
import packageJson from '../../package.json'
import { routes } from './app.routes'

function setup(loaderService: LoaderService) {
    ENV.name = "interview-app"
    ENV.version = packageJson.version
    //Configure location of configuration-services on all hosts
    ENV.configServiceHostMap = {
        'localhost:4200': 'http://localhost:8083',
        'localhost:4600': 'http://localhost:8083',
        'uat-ai.myintent.life': 'https://uat-services.myintent.life/config-services',
        'uat-ai.bequeathed.org': 'https://uat-services.bequeathed.org/config-services',
        'preprod-ai.myintent.life': 'https://preprod-services.myintent.life/config-services',
        'preprod-ai.bequeathed.org': 'https://preprod-services.bequeathed.org/config-services',
        'ai.myintent.life': 'https://services.myintent.life/config-services',
        'ai.bequeathed.org': 'https://services.bequeathed.org/config-services',
    }

    // Enumeration of all the exposed microservices
    ServiceType.AI_MANAGER = 'AI_MANAGER'
    ServiceType.CALENDLY = 'CALENDLY'
    ServiceType.CHARITY = 'CHARITY'
    ServiceType.CONFIG = 'CONFIG'
    ServiceType.CONTENT = 'CONTENT'
    ServiceType.DATA = 'DATA'
    ServiceType.DOCUMENT_MANAGER = 'DOCUMENT_MANAGER'
    ServiceType.INTERCOM = 'INTERCOM'
    ServiceType.INTERVIEW = 'INTERVIEW'
    ServiceType.LAWFIRM = 'LAWFIRM'
    ServiceType.LOCATION = 'LOCATION'
    ServiceType.REPORT = 'REPORT'
    ServiceType.REPORT_GENERATOR = 'REPORT_GENERATOR'
    ServiceType.RESOURCE = 'RESOURCE'
    ServiceType.RULES_ENGINE = 'RULES_ENGINE'
    ServiceType.SECURITY = 'SECURITY'

    // Enumeration of all the web applications
    ApplicationType.HOME = 'HOME'
    ApplicationType.AI_INTERVIEW = 'AI_INTERVIEW'
    ApplicationType.MANAGEMENT = 'MANAGEMENT'

    return () => loaderService.initialiseApp()
}

const scrollingFeature = withInMemoryScrolling({
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
})

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: setup,
            deps: [LoaderService],
            multi: true
        },
        provideRouter(
            routes,
            scrollingFeature
        )
    ]
}
